<script>
import FooterSocial from 'sales-flow-ui/components/SocialLinks';

import FooterColumn from './FooterColumn';
import FooterCurrency from './FooterCurrency';

class FooterLink {
  constructor(text, uri, external = false, hash) {
    this.text = text;
    this.uri = uri;
    this.external = external;
    this.hash = hash;
  }
};

export default {
  components: {
    FooterColumn,
    FooterSocial,
    FooterCurrency,
  },
  data: () => ({
    columns: {
      Company: [
        new FooterLink('About Us', 'about'),
        new FooterLink('Blog', 'http://sellers.viralstyle.com/blog/', true),
        new FooterLink('Career', 'careers'),
        // new FooterLink('Press', 'press'),
        new FooterLink('Partner with us', 'partnerships'),
      ],
      'For Sellers': [
        new FooterLink('Start Selling', 'openShop'),
        new FooterLink('ViralStyle Academy', 'http://sellers.viralstyle.com/', true),
      ],
      Help: [
        new FooterLink('Track Order', 'trackOrder'),
        new FooterLink('Help Center', 'https://viralstyle.zendesk.com/hc/en-us', true),
        new FooterLink('FAQs', 'faq'),
        new FooterLink('Returns', 'terms', false, '#return-policy'),
        new FooterLink('Contact Us', 'contact'),
      ],
    },
    heights: {
      Company: 192,
      'For Sellers': 120,
      Help: 192,
    }
  }),
};
</script>

<template lang='pug'>
.bg-brand-secondary.font-archivo-narrow
  .container.py-3.flex.mx-auto.px-1.flex-wrap.justify-around.lg_justify-between.md_py-5
    footer-column(
      v-for='(links, title) in columns',
      :key='title',
      :title='title',
      :links='links',
      :open-default='title === "Company"',
      :height='heights[title]',
    )
    .flex.w-full.mt-2.md_mt-3.lg_w-1-2.lg_mt-0.justify-around.flex-wrap
      footer-social
      footer-currency
</template>

<style>
@import '~import/index';
</style>